<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <div class="top_cent_p">
              <i class="el-icon-location"></i>
              <el-dropdown trigger="click" class="koaa">
                <!-- <span class="el-dropdown-link" v-if="namee == ''">
              天津市
              <i class="el-icon-arrow-down el-icon--right"></i>
                </span>-->
                <span class="el-dropdown-link" v-if="getCitys[citr].city_name">
                  {{getCitys[citr].city_name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="koa">
                  <el-dropdown-item
                    v-for="(item,index) in getCitys"
                    :key="index"
                    @click.native="dropdown(item.id,index)"
                  >{{item.city_name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <i class="el-icon-arrow-down icon"></i> -->
            </div>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{name:'login'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li @click="dialogVisible = true">
              <a href="#">登录</a>
            </li>
            <li>|</li>
            <li @click="dialogVisible1 = true">
              <a href="#">注册</a>
            </li>
            <li>
              <a href="https://coc.sqifu.com" target="_blank">商会后台</a>
            </li>
            <router-link :to="{path:'/fuwushang'}" tag="li">
              <a href="#">卖家中心</a>
            </router-link>
            <li>
              <a href="http://zf.sqifu.com">政府机构</a>
            </li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <div class="banner">
      <img src="../../assets/img/jieju/fws_banner.png" class="img_banner" alt />
      <div class="banner_1">
        <div class="banner_left">
          <img src="../../assets/img/guanyu/sh_logo.png" alt />
          <p>一站式企服解决方案 助力企业决胜互联网+时代</p>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="cent">
      <div class="cent_1">
        <h1>帮助服务商解决四大痛点问题</h1>
        <ul class="cent_ul">
          <li class="cent_li" :style="cent_li" style="margin:0;">
            <div class="kong"></div>
            <p class="cent_p">客户管理难</p>
            <p>没有专业的客户管理系统 企业运营效率低</p>
          </li>
          <li class="cent_li1" :style="cent_li1">
            <div class="kong"></div>
            <p class="cent_p">拓客难，成本高</p>
            <p>广告成本高 拓展新客户难</p>
          </li>
          <li class="cent_li2" :style="cent_li2">
            <div class="kong"></div>
            <p class="cent_p">订单渠道少</p>
            <p>订单获取渠道少</p>
          </li>
          <li class="cent_li3" :style="cent_li3">
            <div class="kong"></div>
            <p class="cent_p">客户粘度低</p>
            <p>无法进行客户分析及营销</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="tigong">
      <div class="tigong_1">
        <h1>我们为您提供</h1>
        <div class="tigong_neir">
          <img src="../../assets/img/jieju/fws_img_app.png" alt />
        </div>
        <div class="tigong_neir_2">
          <div class="tigong_neir_p">
            <p>免费为服务商提供CRM系统及线上店铺入驻。不只是线上商城，更是客户管理、线下收款及客户营销之利器。</p>
            <div class="kong"></div>
          </div>
          <img src="../../assets/img/jieju/fws_img_system.png" alt />
        </div>
      </div>
    </div>
    <div class="qiang">
      <div class="qiang_1">
        <h1>强化订单协同效率</h1>
        <div class="qiang_2">
          <img src="../../assets/img/jieju/fws_bg_strengthen.png" alt class="qiang_img" />
          <ul>
            <li>
              <img src="../../assets/img/jieju/fws_icon_strengthen01.png" alt />
              <p class="qiang_2p">电子化交易流程</p>
              <p class="qiang_2p1">获取交易信息 规范交易过程</p>
            </li>
            <li>
              <img src="../../assets/img/jieju/fws_icon_strengthen02.png" alt />
              <p class="qiang_2p">降低经营成本</p>
              <p class="qiang_2p1">减少人力投入 减少错误交易</p>
            </li>
            <li>
              <img src="../../assets/img/jieju/fws_icon_strengthen03.png" alt />
              <p class="qiang_2p">提高用户粘度</p>
              <p class="qiang_2p1">方便客户操作 养成客户习惯</p>
            </li>
            <li>
              <img src="../../assets/img/jieju/fws_icon_strengthen04.png" alt />
              <p class="qiang_2p">低成本扩展服务</p>
              <p class="qiang_2p1">同类目扩展 多类目扩展</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content1">
      <div class="content1_1">
        <div class="content1_one">
          <h1>服务商入驻流程</h1>
          <div class="content_two">
            <ul>
              <li>
                <img src="../../assets/img/jieju/fws_icon_step01.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/jieju/fws_icon_step02.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/jieju/fws_icon_step03.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/jieju/fws_icon_step04.png" alt />
              </li>
              <li>
                <img src="../../assets/img/sh_icon_stop_next.png" alt />
              </li>
              <li>
                <img src="../../assets/img/jieju/fws_icon_step05.png" alt />
              </li>
            </ul>
          </div>
          <div class="content_two_1">
            <ul>
              <li style="margin:0">
                <p>申请入驻</p>
                <p style="font-size:14px;color:#666666">在线注册认证 提交申请</p>
              </li>
              <li>
                <p>店铺维护</p>
                <p style="font-size:14px;color:#666666">导入客户信息 上线服务</p>
              </li>
              <li>
                <p>在线接单</p>
                <p style="font-size:14px;color:#666666">实时关注消息通知 与客户沟通在线接单</p>
              </li>
              <li>
                <p>订单服务</p>
                <p style="font-size:14px;color:#666666">根据订单需求 为客户提供服务</p>
              </li>
              <li>
                <p>提现</p>
                <p style="font-size:14px;color:#666666">客户验收后 提现服务费</p>
              </li>
            </ul>
          </div>
          <div class="content_two_2">
            <img src="../../assets/img/jieju/fws_bg_settled in.png" alt />
            <p>免费享受CRM系统，客户&店铺管理更便捷</p>
            <p style="font-size:16px;" class="content_two_2p" @click="settled()">
              <a href="#">马上入驻</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor()">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">登录</a>
        </div>
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==0">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==1">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">登录</a>
        </div>
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==1">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==0">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoginphone, getLogin, getRegionList, getLogon } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      cent_li: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question01.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      cent_li1: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question02.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      cent_li2: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question03.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      cent_li3: {
        backgroundImage:
          "url(" + require("../../assets/img/sh_img_question04.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center"
      },
      //登录
      dialogVisible: false,
      dialogVisible1: false,
      num: 0,
      TIME_COUNT: 60, //验证码倒计时60s
      form: {
        phone: "",
        ecord: ""
      },
      formLogon: {
        phone: "",
        ecord: "",
        name: "",
        enterprise_name: "",
        office_address_province_id: "",
        detailed_address: ""
      },
      count: "",
      show: true,
      cang: false,
      num1: 2,
      options: [],
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      },
      //划过
      munn() {
        this.num1 = 1;
      },
      munn1() {
        this.num1 = 2;
      }
      ,
      getCitys:[]
    };
  },
  methods: {
    // 跳转
    floor() {
      this.$router.push({ name: "guanyu" });
    },
    leimu() {
      this.$router.push({ name: "home" });
    },
    //登录
    getCode(form) {
      if (!/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.form.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    login() {
      if (this.form.ecord == "") {
        this.$message({
          message: "请输入验证码"
        });
      } else {
        getLogin({
          phone: this.form.phone,
          ecord: this.form.ecord
        }).then(res => {
          console.log(res);
          this.login_login = res.data;
          console.log(this.login_login);
          if (res.data.errcode === 200) {
            this.dialogVisible = false;
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push({
              name: "home",
              query: {
                id: res.data.data.name,
                idimg: res.data.data.photo,
                token: res.data.data.token
              }
            });
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("phone", res.data.data.phone);
            localStorage.setItem("photo", res.data.data.photo);
            localStorage.setItem("member_id", res.data.data.member_id);
            localStorage.setItem("is_service", res.data.data.is_service);
          } else if (res.data.errcode == 406) {
            this.$message({
              message: "账号信息不存在，请先注册"
            });
          }
        });
      }
    },
    //注册并登录
    getCode1(formLogon) {
      if (!/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.formLogon.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getlogon() {
      getLogon({
        name: this.formLogon.name,
        phone: this.formLogon.phone,
        ecord: this.formLogon.ecord,
        enterprise_name: this.formLogon.enterprise_name,
        office_address_province_id: this.formLogon.office_address_province_id,
        detailed_address: this.formLogon.detailed_address
      }).then(res => {
        this.logon_logon = res.data.errcode;
        if (res.data.errcode == 200) {
          this.$router.push({
            name: "home",
            query: {
              id: this.formLogon.name
            }
          });
          localStorage.setItem("name", this.formLogon.name);
          localStorage.setItem("is_service", res.data.data.is_service);
        }
        if (res.data.errcode === 20001) {
          this.$message({
            message: "该手机号已经是会员",
            type: "success"
          });
        }
      });
    },
    handleChange(value) {
      console.log(value);
      let labels = this.$refs["cascaderAddr"].currentLables;
      console.log(this.$refs["cascaderAddr"]);
    },
    getRegion() {
      getRegionList({}).then(res => {
        console.log(res);
        this.options = res.data.data;
      });
    },
    checlogin() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          this.$emit("header", false); //是否显示头部
        } else {
          this.$emit("header", true); //是否显示头部
        }
      });
    },
    settled() {
      this.$router.push({
        name: "settled"
      });
    },
     getCity() {
      this.$http("https://ctapi.sqifu.com/api/v1/getCityList", {}, "post").then(
        res => {
          this.getCitys = res.data.data;
        }
      );
    },
    dropdown(id, index) {
      this.citr = index;
      localStorage.setItem("city_id", id);
      localStorage.setItem("citr", this.citr);
      this.$router.go(0);
    }
  },
  created() {
    this.getRegion(); //城市
    this.checlogin();
    this.citr = localStorage.getItem("citr");
    this.getCity();
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  float: left;
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: auto;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.banner {
  width: 100%;
  height: 590px;
  position: relative;
}

.img_banner {
  width: 100%;
  height: 100%;
}

.banner_1 {
  width: 1200px;
  height: 560px;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -600px;
}

.banner_left {
  width: 473px;
  height: auto;
  float: left;
}

.banner_left img {
  padding: 39px 0;
  margin-bottom: 50px;
}

.banner_left p {
  font-size: 40px;
  color: #fff;
  line-height: 60px;
}

.banner_right {
  width: 370px;
  height: auto;
  float: right;
}

.banner_right_1 {
  width: 100%;
  height: 370px;
  margin-top: 80px;
  background: #fff;
  border-radius: 5px;
}

/* 内容 */
.cent {
  width: 100%;
  height: auto;
  background: #f8faff;
  overflow: hidden;
}

.cent_1 {
  width: 1200px;
  height: 434px;
  margin: 0 auto;
}

.cent_1 h1,
.content_1 h1 {
  text-align: center;
  margin-top: 95px;
  margin-bottom: 80px;
}

.cent_ul li {
  width: 144px;
  height: 170px;
  margin-left: 205px;
  float: left;
}

.cent_ul li p {
  line-height: 23px;
}

.cent_ul li p:last-child {
  text-align: center;
  font-size: 14px;
  color: #666666;
}

.cent_p {
  color: #222222;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.kong {
  width: 100%;
  height: 99px;
}

.content {
  width: 100%;
  height: auto;
  margin-bottom: 144px;
}

.content_1 {
  width: 1200px;
  height: 828px;
  margin: 0 auto;
  position: relative;
}

.content_cent {
  width: 450px;
  height: auto;
  float: right;
  margin-right: 0px;
  margin-top: 150px;
}

.content_cent_p {
  width: 350px;
  color: #222;
  font-size: 14px;
  margin-bottom: 40px;
}

.content_cent1 {
  width: 100%;
  height: 194px;
  border-top: 1px solid #e4e4e4;
}

.content_cent1 ul {
  margin-top: 40px;
}

.content_cent1 ul li {
  width: 36px;
  height: 55px;
  float: left;
  margin: 0 0 0 60px;
  border-bottom: 2px solid #007bff;
  font-size: 18px;
  font-weight: 600;
}

.content_cent1 ul li:first-child {
  margin: 0;
}

.img_content {
  position: absolute;
  bottom: 0;
  left: -50%;
  margin-left: 200px;
}

.content1 {
  width: 100%;
  height: auto;
}

.content1_1 {
  width: 1200px;
  height: 628px;
  margin: 0 auto;
}

.content1_one {
  width: 100%;
  height: 380px;
  margin-bottom: 120px;
}

.content1_one h1 {
  text-align: center;
  margin-bottom: 22px;
  margin-top: 95px;
}

.content_two {
  width: 1200px;
  height: 54px;
  margin: 61px auto;
  margin-bottom: 27px;
}

.content_two ul li {
  float: left;
  padding: 0 0 0 40px;
  line-height: 54px;
}

.content_two_1 {
  width: 100%;
  height: 60px;
  margin-bottom: 59px;
}

.content_two_1 ul {
  display: flex;
}

.content_two_1 ul li {
  width: 20%;
  height: 18px;
  text-align: center;
  margin-left: 120px;
}

.content_two_1 ul li p {
  width: 150px;
  line-height: 22px;
}

.content_two_2 {
  width: 1200px;
  height: 144px;
  position: relative;
  overflow: hidden;
}

.content_two_2 img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.content_two_2 p {
  font-size: 24px;
  color: #fff;
  text-align: center;
  margin-top: 24px;
}

.content_two_2p {
  width: 150px;
  height: 44px;
  background: #fff;
  margin: 0 auto;
  color: #007bff;
}

.content_two_2p a {
  color: #007bff;
  line-height: 44px;
}

.content1_tree {
  width: 100%;
  height: 504px;
  background: #2b2876;
}

.tigong {
  width: 100%;
  height: auto;
}

.tigong_1 {
  width: 1200px;
  height: 720px;
  margin: 0 auto;
}

.tigong_1 h1 {
  text-align: center;
  margin-top: 95px;
  margin-bottom: 62px;
}

.tigong_neir {
  width: 630px;
  height: 464px;
  float: left;
}

.tigong_neir_2 {
  width: 570px;
  height: auto;
  float: right;
}

.tigong_neir_p {
  width: 570px;
  height: 187px;
  overflow: hidden;
}

.tigong_neir_p p {
  width: 341px;
  font-size: 14px;
  margin: 45px 0 0 85px;
}

.kong1 {
  width: 41px;
  height: 6px;
  background: linear-gradient(
    90deg,
    rgba(0, 123, 255, 1),
    rgba(115, 76, 231, 1)
  );
  margin: 34px 0 0 85px;
}

.qiang {
  width: 100%;
  height: auto;
  background: #2b2876;
}

.qiang_1 {
  width: 1200px;
  height: 504px;
  margin: 0 auto;
  overflow: hidden;
}

.qiang_1 h1 {
  text-align: center;
  margin: 82px 0 43px 0;
  color: #fff;
}

.qiang_2 {
  width: 1200px;
  height: 336px;
  position: relative;
}

.qiang_img {
  position: absolute;
  top: 0;
  left: 0;
}

.qiang_2 ul li {
  width: 300px;
  height: auto;
  float: left;
  text-align: center;
}

.qiang_2 ul li img {
  margin-top: 48px;
  margin-bottom: 35px;
}

.qiang_2p {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
  margin-bottom: 25px;
}

.qiang_2p1 {
  width: 90px;
  font-size: 14px;
  margin: 0 auto;
  color: #fff;
}

/* denglu */
.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  margin: 0 auto;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro1 {
  width: 322px;
  height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  position: relative;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}
.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  margin-bottom: 20px;
}

.login2_1_one {
  width: 322px;
  height: 550px;
  margin: 20px auto;
}

.login_three {
  width: 100%;
  height: 20px;
  margin-bottom: 20px;
}

.login_three img {
  float: left;
  padding: 0 5px 0 0;
}

.login_three p {
  float: left;
  line-height: 15px;
}

.top_ul li a {
  color: #666666;
}

.koa {
  width: auto;
  text-align: center;
  margin-top: -5px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Jiejue/Fuwushang.vue